const ImageCTAMeatball = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34">
			<path
				className="circle"
				d="M33.667 17c0 9.205-7.462 16.667-16.667 16.667C7.795 33.667.333 26.205.333 17 .333 7.795 7.795.333 17 .333 26.205.333 33.667 7.795 33.667 17Z"
			/>
			<path
				className="chevron"
				d="m15.087 12-1.175 1.175L17.73 17l-3.817 3.825L15.087 22l5-5-5-5Z"
			/>
		</svg>
	);
};
export default ImageCTAMeatball;
